var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"xl":"10","lg":"10","md":"12","sm":"12"}},[_c('top-card',{attrs:{"user":_vm.user}}),_c('Form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }